import React from 'react';
import Link from 'next/link';

interface DonationButtonProps {
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
  title?: string;
  children?: React.ReactNode;
}

const DonationButton: React.FC<DonationButtonProps> = ({ className, style, 'aria-label': ariaLabel, title, children }) => {
  return (
    <Link
      href="/donate"
      className={`btn btn--secondary ${className || ''}`}
      style={style}
      aria-label={ariaLabel || "Navigate to donation page"}
      title={title || "Click to make a donation"}
    >
      {children || "Donate Now"}
    </Link>
  );
};

export default DonationButton;